// extracted by mini-css-extract-plugin
export default {"vnForm":"addVNModal_vnForm__F8-j5","action_btn":"addVNModal_action_btn__8o8PF"};